import styled from 'styled-components';

export const dayToColorMap: Record<number, string> = {
  0: '#959595',
  1: '#225A91',
  2: '#229162',
  3: '#8F9122',
  4: '#C98568',
  5: '#91225E',
  6: '#912222',
  7: '#228A91'
};

const MapPinIcon = ({ fillColor, type }: { fillColor: string; type: 'web' | 'map' }) => {
  if (type === 'map') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="38" viewBox="0 0 31 38" fill="none">
        <mask id="path-1-inside-1_5898_4995" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.8573 37.9151C15.0503 37.9794 15.2593 38.0116 15.4844 38.0116C15.6774 38.0116 15.8623 37.9794 16.0391 37.9151C16.216 37.8508 16.3848 37.7543 16.5456 37.6257C21.3373 33.4129 24.923 29.5056 27.3027 25.9038C29.6825 22.3021 30.8723 18.9415 30.8723 15.8221C30.8723 10.9983 29.3207 7.15531 26.2174 4.29319C23.1141 1.43106 19.5203 0 15.4362 0C11.352 0 7.75828 1.43106 4.65497 4.29319C1.55166 7.15531 0 10.9983 0 15.8221C0 18.9415 1.18987 22.3021 3.56961 25.9038C5.94936 29.5056 9.53505 33.4129 14.3267 37.6257C14.4875 37.7543 14.6644 37.8508 14.8573 37.9151Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.8573 37.9151C15.0503 37.9794 15.2593 38.0116 15.4844 38.0116C15.6774 38.0116 15.8623 37.9794 16.0391 37.9151C16.216 37.8508 16.3848 37.7543 16.5456 37.6257C21.3373 33.4129 24.923 29.5056 27.3027 25.9038C29.6825 22.3021 30.8723 18.9415 30.8723 15.8221C30.8723 10.9983 29.3207 7.15531 26.2174 4.29319C23.1141 1.43106 19.5203 0 15.4362 0C11.352 0 7.75828 1.43106 4.65497 4.29319C1.55166 7.15531 0 10.9983 0 15.8221C0 18.9415 1.18987 22.3021 3.56961 25.9038C5.94936 29.5056 9.53505 33.4129 14.3267 37.6257C14.4875 37.7543 14.6644 37.8508 14.8573 37.9151Z"
          fill={fillColor}
        />
        <path
          d="M14.8573 37.9151L13.5924 41.7098L13.5924 41.7098L14.8573 37.9151ZM16.0391 37.9151L17.4061 41.6743L17.4062 41.6743L16.0391 37.9151ZM16.5456 37.6257L19.0444 40.7491L19.117 40.6911L19.1868 40.6297L16.5456 37.6257ZM27.3027 25.9038L30.6401 28.1089L27.3027 25.9038ZM26.2174 4.29319L23.5055 7.23357L26.2174 4.29319ZM4.65497 4.29319L1.94311 1.3528L1.94311 1.3528L4.65497 4.29319ZM3.56961 25.9038L6.90696 23.6988L3.56961 25.9038ZM14.3267 37.6257L11.6855 40.6297L11.7553 40.6911L11.8279 40.7491L14.3267 37.6257ZM15.4844 34.0116C15.6437 34.0116 15.8662 34.035 16.1222 34.1204L13.5924 41.7098C14.2343 41.9238 14.8749 42.0116 15.4844 42.0116V34.0116ZM14.6722 34.1559C14.9445 34.0569 15.2231 34.0116 15.4844 34.0116V42.0116C16.1316 42.0116 16.78 41.9019 17.4061 41.6743L14.6722 34.1559ZM14.0469 34.5022C14.1943 34.3842 14.403 34.2538 14.6721 34.1559L17.4062 41.6743C18.029 41.4477 18.5754 41.1244 19.0444 40.7491L14.0469 34.5022ZM23.9654 23.6988C21.8503 26.9 18.5438 30.5427 13.9045 34.6216L19.1868 40.6297C24.1307 36.283 27.9957 32.1112 30.6401 28.1089L23.9654 23.6988ZM26.8723 15.8221C26.8723 17.9099 26.0732 20.5085 23.9654 23.6988L30.6401 28.1089C33.2917 24.0956 34.8723 19.9731 34.8723 15.8221H26.8723ZM23.5055 7.23357C25.6671 9.22716 26.8723 11.9399 26.8723 15.8221H34.8723C34.8723 10.0567 32.9743 5.08345 28.9292 1.3528L23.5055 7.23357ZM15.4362 4C18.4786 4 21.1135 5.02746 23.5055 7.23357L28.9292 1.3528C25.1146 -2.16533 20.562 -4 15.4362 -4V4ZM7.36682 7.23357C9.75884 5.02746 12.3937 4 15.4362 4V-4C10.3103 -4 5.75772 -2.16533 1.94311 1.3528L7.36682 7.23357ZM4 15.8221C4 11.9399 5.20523 9.22716 7.36682 7.23357L1.94311 1.3528C-2.10191 5.08345 -4 10.0567 -4 15.8221H4ZM6.90696 23.6988C4.7991 20.5085 4 17.9099 4 15.8221H-4C-4 19.9731 -2.41935 24.0956 0.232272 28.1089L6.90696 23.6988ZM16.9678 34.6216C12.3285 30.5427 9.02203 26.9 6.90696 23.6988L0.232272 28.1089C2.87668 32.1112 6.74161 36.283 11.6855 40.6297L16.9678 34.6216ZM16.1223 34.1204C16.3826 34.2071 16.6224 34.3398 16.8255 34.5022L11.8279 40.7491C12.3525 41.1688 12.9462 41.4944 13.5924 41.7098L16.1223 34.1204Z"
          fill="white"
          mask="url(#path-1-inside-1_5898_4995)"
        />
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="0 0 22 27" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5999 26.8641C10.7333 26.9085 10.8777 26.9307 11.0333 26.9307C11.1666 26.9307 11.2944 26.9085 11.4166 26.8641C11.5388 26.8196 11.6555 26.753 11.7666 26.6641C15.0777 23.753 17.5555 21.053 19.1999 18.5641C20.8444 16.0752 21.6666 13.753 21.6666 11.5974C21.6666 8.26406 20.5944 5.60851 18.4499 3.63073C16.3055 1.65295 13.8221 0.664062 10.9999 0.664062C8.1777 0.664062 5.69436 1.65295 3.54992 3.63073C1.40547 5.60851 0.333252 8.26406 0.333252 11.5974C0.333252 13.753 1.15547 16.0752 2.79992 18.5641C4.44436 21.053 6.92214 23.753 10.2333 26.6641C10.3444 26.753 10.4666 26.8196 10.5999 26.8641Z"
        fill={fillColor}
      />
    </svg>
  );
};

const Wrapper = styled.div`
  position: relative;
`;

const NumberWrapper = styled.div<{ type: 'web' | 'map' }>`
  position: absolute;
  top: ${props => (props.type === 'map' ? '16px' : '12px')};
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
`;

export const MapPin = ({
  dayNumber,
  orderIndex,
  type = 'web'
}: {
  dayNumber: number;
  orderIndex: number;
  type?: 'web' | 'map';
}) => {
  return (
    <Wrapper>
      <MapPinIcon type={type} fillColor={dayToColorMap[dayNumber]} />
      <NumberWrapper type={type}>{orderIndex}</NumberWrapper>
    </Wrapper>
  );
};
